import firebase from "datastore/database";
import store from "datastore/store";

import { getBusinessPermissions } from "api/permissions";

export default function observeBusinessGroupPermissions(groupBuid) {
  if (!groupBuid) return;
  store.dispatch({ type: "ADD_BUSINESS_GROUP_PERMISSIONS_LOADING" });

  return firebase
    .firestore()
    .doc(`business-groups/${groupBuid}`)
    .onSnapshot(
      async (docSnapshot) => {
        try {
          if (!docSnapshot.exists) {
            store.dispatch({
              type: "ADD_BUSINESS_GROUP_PERMISSIONS_SUCCESS",
              businessGroupPermissions: [],
            });
            return;
          }

          const data = docSnapshot.data();
          const businessUids = data.uids || [];

          const permissionsPromises = businessUids.map(async (businessUid) => {
            const permissions = await getBusinessPermissions(businessUid);
            return {
              ...permissions,
              businessUid,
            };
          });

          const groupPermissions = await Promise.all(permissionsPromises);

          store.dispatch({
            type: "ADD_BUSINESS_GROUP_PERMISSIONS_SUCCESS",
            businessGroupPermissions: groupPermissions,
          });
        } catch (error) {
          store.dispatch({
            type: "ADD_BUSINESS_GROUP_PERMISSIONS_ERROR",
            error,
          });
        }
      },
      (error) => {
        store.dispatch({
          type: "ADD_BUSINESS_GROUP_PERMISSIONS_ERROR",
          error,
        });
      }
    );
}
